export var activityURL = 'v1/credit/accounts/activity';
export default activityURL;
//# sourceMappingURL=activity-api.js.map